import React from "react";
import { Button } from "antd";

export default function DialogFooter({
  onCancel,
  onSave,
  loading,
  saveText = "Save",
  cancelText = "Cancel",
  danger = false,
}) {
  return (
    <div style={{ display: "flex", justifyContent: "flex-end", gap: "8px" }}>
      <Button
        onClick={onCancel}
        style={{ backgroundColor: "#D97A07", color: "#fff", border: "none" }}
      >
        {cancelText}
      </Button>
      <Button
        type="primary"
        onClick={onSave}
        loading={loading}
        style={
          danger
            ? { backgroundColor: "#a71e27" }
            : { backgroundColor: "#0D2E4D" }
        }
      >
        {saveText}
      </Button>
    </div>
  );
}
